export default "__VITE_ASSET__DMyMfBJr__"